import gql from 'graphql-tag';
import Customer from './Customer';
import Member from './Member';

export default gql`
    fragment Invoice on CMInvoice {
        ID
        Created
        Hena
        InvoiceDate
        InvoiceDueDate
        InvoiceSent
        InvoicePaid
        GstAmount
        Total
        XeroID
        XeroStatus
        XeroReference
        IsPurchase
        Archived
        Notes
        Customer{
            ...Customer
        }
        CreatedBy {
            ...Member
        }
        InvoiceItems {
            ID
            ItemCode
            Title
            Price
            Quantity
            Prepaid
            HasGST
            XeroAccount
            ProductID
            VariationID
            Sort
        }
    }
    ${Customer}
    ${Member}
`;
